const React = require('react');
const upperFirst = require('mn-utils/upperFirst');

const formatNumFiat = require('../../../../../../utils/formatNumFiat');
const formatCCSymbol = require('../../../../../../utils/formatCCSymbol');

const RowA = require('../../../../../dumb/Row/A');
const ColA = require('../../../../../dumb/Col/A');
const Tooltip = require('../../../../../dumb/Tooltip/A');

const {
  DisplayIdAdmin,
  DisplayDataAdmin,
  DisplayAmountAdmin,
  DisplayHashAdmin,
  DisplayDateTimeAdmin
} = require("../../../../../dumb/DisplayData");

const Ripple = require("../../../../../dumb/Ripple");
const ColA2 = require("../../../../../dumb/Col/A2");
const PencilIcon = require("../../../../../icons/Pencil");

const openStatusChangePopup = require('./utils/openStatusChangePopup');
const getExplorerUrlPrefixByCoin = require("../../../../../../utils/getExplorerUrlPrefixByCoin");

module.exports = ({data, update}) => {
  const isFiat = !!data.account_fiat_amount;
  const fiatValue = data.account_fiat_amount || data.account_sc_amount || 0;
  const fiatCode = data.account_fiat_code || data.account_sc_code || '';
  const ccValue = data.cc_value || 0;
  const ccCode = data.cc_code || '';
  const exchangeRate = data.exchange_rate || 0;
  const id = data.id || '';
  const time = data.time || '';

  const enableStatusChange = ['CANCELLED', 'TIMEOUT'].includes(data.auction_status)
    && ['pending', 'expired', 'none'].includes(data.order_status);

  return (
    <RowA className="f12">
      <ColA className="wmin155 fx1">
        <DisplayIdAdmin>{id}</DisplayIdAdmin>
      </ColA>
      <ColA className="wmin120">
        <DisplayDateTimeAdmin date={time} />
      </ColA>
      <ColA className="wmin110 fx1">
        <DisplayDataAdmin>{data.merchant_login}</DisplayDataAdmin>
      </ColA>
      <ColA className="wmin110 fx1">
        <DisplayDataAdmin>{data.customer_email}</DisplayDataAdmin>
      </ColA>
      <ColA className="wmin100 fx1">
        <DisplayDataAdmin>{data.auction_status}</DisplayDataAdmin>
      </ColA>
      <ColA className="wmin140 fx1 tr">
        <DisplayAmountAdmin
          amount={fiatValue}
          symbol={fiatCode}
          type={!!data.account_fiat_amount ? 'fiat' : 'coin'}
        />
      </ColA>
      <ColA className="wmin180 fx1 tr pr15">
        <DisplayAmountAdmin
          amount={ccValue}
          symbol={formatCCSymbol(ccCode)}
          type="coin"
        />
      </ColA>
      <ColA className="wmin80 fx1">
        <Tooltip title={exchangeRate}>
          {formatNumFiat(exchangeRate)}
        </Tooltip>
      </ColA>
      {/* <ColA className="wmin100 fx1"> */}
      {/*  <Tooltip>{data.payment_status || 'none'}</Tooltip> */}
      {/* </ColA> */}
      <ColA className="wmin180 fx1">
        <DisplayHashAdmin symbol={ccCode} hash={data.tx_hash} />
      </ColA>
      <ColA className="wmin160 fx1">
        <DisplayDataAdmin>
          {upperFirst(data.order_status)}
        </DisplayDataAdmin>
      </ColA>
      <ColA2 className="w50">
        {enableStatusChange ? (
          <Tooltip title="Manual Acceptance" disabledCopy>
            <Ripple
              className="w42 h42 p7 r7 (bgc0.25):h:not[.disabled] o15.disabled"
              onClick={() => openStatusChangePopup(data, update)}
            >
              <PencilIcon className="w25 h25"/>
            </Ripple>
          </Tooltip>
        ) : (
          <div
            className="w42 h42 p7 r7 o15"
          >
            <PencilIcon className="w25 h25"/>
          </div>
        )}
      </ColA2>
    </RowA>
  );
};
